/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PalReauthSubmissionStatus } from './PalReauthSubmissionStatus';
import {
    PalReauthSubmissionStatusFromJSON,
    PalReauthSubmissionStatusFromJSONTyped,
    PalReauthSubmissionStatusToJSON,
    PalReauthSubmissionStatusToJSONTyped,
} from './PalReauthSubmissionStatus';
import type { UpdatePalReauthSubmissionRequestCaseManager } from './UpdatePalReauthSubmissionRequestCaseManager';
import {
    UpdatePalReauthSubmissionRequestCaseManagerFromJSON,
    UpdatePalReauthSubmissionRequestCaseManagerFromJSONTyped,
    UpdatePalReauthSubmissionRequestCaseManagerToJSON,
    UpdatePalReauthSubmissionRequestCaseManagerToJSONTyped,
} from './UpdatePalReauthSubmissionRequestCaseManager';
import type { UploadPalReportToExternalEhrConfig } from './UploadPalReportToExternalEhrConfig';
import {
    UploadPalReportToExternalEhrConfigFromJSON,
    UploadPalReportToExternalEhrConfigFromJSONTyped,
    UploadPalReportToExternalEhrConfigToJSON,
    UploadPalReportToExternalEhrConfigToJSONTyped,
} from './UploadPalReportToExternalEhrConfig';
import type { PalReauthSubmissionStatusInfo } from './PalReauthSubmissionStatusInfo';
import {
    PalReauthSubmissionStatusInfoFromJSON,
    PalReauthSubmissionStatusInfoFromJSONTyped,
    PalReauthSubmissionStatusInfoToJSON,
    PalReauthSubmissionStatusInfoToJSONTyped,
} from './PalReauthSubmissionStatusInfo';

/**
 * 
 * @export
 * @interface UpdatePalReauthSubmissionRequest
 */
export interface UpdatePalReauthSubmissionRequest {
    /**
     * 
     */
    status?: PalReauthSubmissionStatus;
    /**
     * 
     */
    status_info?: PalReauthSubmissionStatusInfo;
    /**
     * 
     */
    external_id?: string | null;
    /**
     * 
     */
    next_review_date?: string | null;
    /**
     * ID of an existing case manager to assign
     */
    case_manager_id?: string | null;
    /**
     * 
     */
    case_manager?: UpdatePalReauthSubmissionRequestCaseManager;
    /**
     * 
     */
    upload_pal_report_to_external_ehr_config?: UploadPalReportToExternalEhrConfig;
    /**
     * The patient's note, saved in the same transaction as the rest of the update with the same rules as `PUT /pal-reauth-submissions/{id}/note`. Leave it out to keep the note unchanged.
     */
    note?: string;
}



/**
 * Check if a given object implements the UpdatePalReauthSubmissionRequest interface.
 */
export function instanceOfUpdatePalReauthSubmissionRequest(value: object): value is UpdatePalReauthSubmissionRequest {
    return true;
}

export function UpdatePalReauthSubmissionRequestFromJSON(json: any): UpdatePalReauthSubmissionRequest {
    return UpdatePalReauthSubmissionRequestFromJSONTyped(json, false);
}

export function UpdatePalReauthSubmissionRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdatePalReauthSubmissionRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'status': json['status'] == null ? undefined : PalReauthSubmissionStatusFromJSON(json['status']),
        'status_info': json['status_info'] == null ? undefined : PalReauthSubmissionStatusInfoFromJSON(json['status_info']),
        'external_id': json['external_id'] === undefined ? undefined : json['external_id'] === null ? null : json['external_id'],
        'next_review_date': json['next_review_date'] === undefined ? undefined : json['next_review_date'] === null ? null : json['next_review_date'],
        'case_manager_id': json['case_manager_id'] === undefined ? undefined : json['case_manager_id'] === null ? null : json['case_manager_id'],
        'case_manager': json['case_manager'] == null ? undefined : UpdatePalReauthSubmissionRequestCaseManagerFromJSON(json['case_manager']),
        'upload_pal_report_to_external_ehr_config': json['upload_pal_report_to_external_ehr_config'] == null ? undefined : UploadPalReportToExternalEhrConfigFromJSON(json['upload_pal_report_to_external_ehr_config']),
        'note': json['note'] == null ? undefined : json['note'],
    };
}

export function UpdatePalReauthSubmissionRequestToJSON(json: any): UpdatePalReauthSubmissionRequest {
    return UpdatePalReauthSubmissionRequestToJSONTyped(json, false);
}

export function UpdatePalReauthSubmissionRequestToJSONTyped(value?: UpdatePalReauthSubmissionRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'status': PalReauthSubmissionStatusToJSON(value['status']),
        'status_info': PalReauthSubmissionStatusInfoToJSON(value['status_info']),
        'external_id': value['external_id'],
        'next_review_date': value['next_review_date'],
        'case_manager_id': value['case_manager_id'],
        'case_manager': UpdatePalReauthSubmissionRequestCaseManagerToJSON(value['case_manager']),
        'upload_pal_report_to_external_ehr_config': UploadPalReportToExternalEhrConfigToJSON(value['upload_pal_report_to_external_ehr_config']),
        'note': value['note'],
    };
}

